import { renderToast, toast } from 'components/UI/ToastNotification';
import Vendor from 'data/Vendor';
import { BusinessUnit } from 'data/BusinessUnit';
import { VALIDATION_MESSAGES } from 'constants/general';

export const validateProductCreation = (
  selectedVendor: Vendor | undefined,
  selectedBusinessUnit: BusinessUnit | undefined,
  isBusinessUnitFeatureEnabled: boolean
): boolean => {
  if (!selectedVendor) {
    renderToast(toast.TYPE.INFO, VALIDATION_MESSAGES.SELECT_VENDOR);
    return false;
  }

  if (!selectedBusinessUnit && isBusinessUnitFeatureEnabled) {
    renderToast(toast.TYPE.INFO, VALIDATION_MESSAGES.SELECT_BUSINESS_UNIT);
    return false;
  }

  return true;
};
   
